import classNames from 'classnames';
import React from 'react';
import { IconProps } from '../types/icon';
import styles from './icon.module.sass';

export default function IconChevronDownSmall({ className }: IconProps) {
  return (
    <svg
      className={classNames(styles.icon, className)}
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.79289 10.2929C8.18342 9.90237 8.81658 9.90237 9.20711 10.2929L12.5 13.5858L15.7929 10.2929C16.1834 9.90237 16.8166 9.90237 17.2071 10.2929C17.5976 10.6834 17.5976 11.3166 17.2071 11.7071L13.2071 15.7071C12.8166 16.0976 12.1834 16.0976 11.7929 15.7071L7.79289 11.7071C7.40237 11.3166 7.40237 10.6834 7.79289 10.2929Z"
        fill="black"
      />
    </svg>
  );
}
